import { render } from "./Receiver.vue?vue&type=template&id=7cc45f77"
import script from "./Receiver.vue?vue&type=script&lang=js"
export * from "./Receiver.vue?vue&type=script&lang=js"
script.render = render

export default script